import { Checkbox } from 'primereact/checkbox';
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import useCotizacion from 'src/hooks/useCotizacion';
import usePageValidation from 'src/hooks/usePageValidation';
import { setBeneficiarioIgualTitularAction } from 'src/reducers/Cotizacion/cotizacion.actions';
import { guardarLead } from 'src/services';

const CheckBeneficiarioIgualTitular = ({
  onCheckBeneficiarioIgualTitular,
}: {
  onCheckBeneficiarioIgualTitular: CallableFunction;
}) => {
  const { cotizacion, idCotizacion } = useCotizacion();

  const dispatch = useDispatch();

  const [pageProps, setPageProps1] = useState({
    label: null,
    labelText: 'Beneficiario igual al titular',
  });

  const setPageProps = (value) => {
    setPageProps1(value);
  }

  const { execEvent, isLoadingCallbacks } = usePageValidation('paginaCompra');

  const onCheck = (evt: PrimeCheckBoxPropsEvent) => {
    guardarLead(idCotizacion, `PAGINA_COMPRA__CHECK_BENEFICIARIO_IGUAL_TITULAR__${evt.checked}`);
    const { titular } = cotizacion;
    dispatch(setBeneficiarioIgualTitularAction(evt.checked));
    onCheckBeneficiarioIgualTitular?.(evt.checked, titular);
  };

  const init = useCallback(async () => {
    await execEvent('initBeneficiarioIgualTitularCallback', {
      pageProps,
      setPageProps,
    });
  }, [isLoadingCallbacks]);

  useEffect(() => {
    init();
  }, [isLoadingCallbacks]);

  if (cotizacion.producto.beneficiarioIgualTitular) {
    return (
      <div className="row justify-content-center">
        <div className="col-12 col-md-9 col-lg-8 col-xl-7 mt-3">
          <div className="p-field p-field-checkbox d-flex flex-row">
            <Checkbox
              inputId="benAsTitular"
              value="Beneficiario igual al titular"
              checked={cotizacion.beneficiarioIgualTitularChecked}
              //@ts-ignore
              onChange={onCheck}
            />
            {!pageProps.label && (
              <label htmlFor="benAsTitular" className="ml-1 font-weight-bold">
                {pageProps.labelText}
              </label>
            )}
            {pageProps.label}
          </div>
        </div>
      </div>
    );
  }
  return null;
};

export default CheckBeneficiarioIgualTitular;

export type PrimeCheckBoxPropsEvent = {
  originalEvent: Event;
  value: any;
  checked: boolean;
  target: { type: string; name: string; id: string; value: any; checked: boolean };
};